/*
  Recenzije po prioritetu (sections/vl-recenzije-prioritet.liquid).
  Žive Ali Reviews recenzije proizvoda preko zajedničkog klijenta assets/vp-ali-reviews.js (bez API ključa),
  isti izvor kao na stranicama proizvoda. Nijedna recenzija se ne izmišlja ni ne menja; menja se samo
  REDOSLED: prvo one koje pominju reči iz „prve", pa sve ostale, pa na kraju one sa rečima iz „poslednje"
  (npr. na lenderu za muškarce: muški oblici prvi, ženski poslednji). Unutar grupe ostaje redosled po datumu.
  Prikazuje se po `per` recenzija uz dugme „Učitaj još". Ako recenzija nema ili servis ne odgovori, blok
  ostaje skriven. Učitavanje kreće tek kad blok priđe ekranu.
*/
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function stemsToRegex(raw) {
    var stems = String(raw || '').split(/[,\n]/)
      .map(function (k) { return k.trim().toLowerCase(); })
      .filter(Boolean)
      .map(function (k) { return k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+'); });
    return stems.length ? new RegExp('(?:^|[^a-zčćžšđ])(?:' + stems.join('|') + ')', 'i') : null;
  }

  function initBox(box) {
    if (!box || box.dataset.vlRvInit === 'true') return;
    box.dataset.vlRvInit = 'true';

    var api = window.VPAliReviews;
    var shop = box.getAttribute('data-shop');
    var pid = box.getAttribute('data-product-id');
    var list = $('[data-vl-rv-list]', box);
    var more = $('[data-vl-rv-more]', box);
    var tpl = $('[data-vl-rv-tpl]', box);
    if (!api || !shop || !pid || !list || !tpl || !tpl.content) { box.setAttribute('hidden', ''); return; }

    var PER = Math.max(1, parseInt(box.getAttribute('data-per'), 10) || 5);
    var MAX = 150;
    var months = (box.getAttribute('data-months') || '').split(',').map(function (m) { return m.trim(); });
    var firstRx = stemsToRegex(box.getAttribute('data-first'));
    var lastRx = stemsToRegex(box.getAttribute('data-last'));
    var ordered = [];
    var shown = 0;
    var started = false;

    function plural(n) {
      var d = n % 10, h = n % 100;
      if (d === 1 && h !== 11) return box.getAttribute('data-count-one') || '';
      if (d >= 2 && d <= 4 && (h < 12 || h > 14)) return box.getAttribute('data-count-few') || '';
      return box.getAttribute('data-count-many') || '';
    }
    function paintStars(holder, rating) {
      $$('svg', holder).forEach(function (svg, i) { svg.style.color = i < rating ? '' : '#d6dde0'; });
    }
    function formatDate(raw) {
      var m = String(raw || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!m) return '';
      var month = months[parseInt(m[2], 10) - 1] || m[2];
      return parseInt(m[3], 10) + ' ' + month + ' ' + m[1];
    }
    function initials(name) {
      var letters = String(name || '').replace(/[^A-Za-zČĆŽŠĐčćžšđ]/g, '');
      return letters.slice(0, 2).toUpperCase();
    }
    function setHidden(el, hidden) {
      if (!el) return;
      if (hidden) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
    }
    function card(r) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var name = String(r.author || '').trim();
      var f = function (k) { return node.querySelector('[data-f="' + k + '"]'); };
      f('name').textContent = name;
      setHidden(f('name'), !name);
      f('initials').textContent = initials(name);
      setHidden(f('initials'), !initials(name));
      setHidden(f('verified'), !r.verified_purchase);
      var rating = Math.max(0, Math.min(5, Math.round(Number(r.star) || 0)));
      paintStars(f('stars'), rating);
      f('stars').setAttribute('aria-label', rating + '/5');
      f('date').textContent = formatDate(r.created_at);
      f('body').textContent = String(r.content || '').trim();
      return node;
    }
    function showMore() {
      var next = ordered.slice(shown, shown + PER);
      var frag = document.createDocumentFragment();
      next.forEach(function (r) { frag.appendChild(card(r)); });
      list.appendChild(frag);
      shown += next.length;
      setHidden(more, shown >= ordered.length);
    }
    function summary(items, total) {
      var sum = 0;
      items.forEach(function (r) { sum += Number(r.star) || 0; });
      var avg = items.length ? Math.round((sum / items.length) * 10) / 10 : 0;
      var wrap = $('[data-vl-rv-summary]', box);
      if (!wrap || !avg) return;
      $('[data-vl-rv-avg]', box).textContent = String(avg).replace('.', ',');
      paintStars($('[data-vl-rv-avg-stars]', box), Math.round(avg));
      $('[data-vl-rv-count]', box).textContent = total + ' ' + plural(total);
      setHidden(wrap, false);
    }
    function start() {
      if (started) return;
      started = true;
      var stream = api.createStream({ shopDomain: shop, productId: pid, order: 'newest' });
      stream.ensure(MAX).then(function (st) {
        var items = st.items.slice();
        $$('[data-vl-rv-skel]', list).forEach(function (el) { el.parentNode.removeChild(el); });
        if (!items.length) { box.setAttribute('hidden', ''); return; }
        var first = [], middle = [], last = [];
        items.forEach(function (r) {
          var text = String(r.content || '');
          if (lastRx && lastRx.test(text)) last.push(r);
          else if (firstRx && firstRx.test(text)) first.push(r);
          else middle.push(r);
        });
        ordered = first.concat(middle, last);
        summary(items, st.exhausted ? items.length : Math.max(st.total, items.length));
        showMore();
      }).catch(function (err) {
        if (window.console) console.warn('[vl-recenzije] recenzije:', err);
        box.setAttribute('hidden', '');
      });
    }

    if (more) more.addEventListener('click', showMore);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (en) { return en.isIntersecting; })) return;
        io.disconnect();
        start();
      }, { rootMargin: '900px 0px' });
      io.observe(box);
    } else {
      start();
    }
  }

  function initAll() { $$('[data-vl-rv]').forEach(initBox); }

  /* Odloženi skriptovi: vp-ali-reviews.js može biti kasnije na strani, pa se čeka DOMContentLoaded/load. */
  if (window.VPAliReviews || document.readyState === 'complete') {
    initAll();
  } else {
    var done = false;
    var go = function () { if (done) return; done = true; initAll(); };
    document.addEventListener('DOMContentLoaded', go);
    window.addEventListener('load', go);
  }
  document.addEventListener('shopify:section:load', function (e) { $$('[data-vl-rv]', e.target).forEach(initBox); });
})();
